<template>
  <div class="about certificate-service certificate">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- 新增资讯内容 -->
    <section>
      <div class="banner">
        <img :src="bannerImg" class="banner-bgimg" />
        <div class="banner-mask">
          <!--<h1 class="banner-title">认证服务管理系统</h1>-->
          <img class="banner-title banner-title-f" src="@/assets/image/service/banner-title.png" />
          <a href="http://ztrz.chinaath.com" class="banner-btn">用户登录</a>
        </div>
      </div>
      <div class="content">
        <div class="service-menu">
          <ul class="menu-list">
            <li v-for="(item, index) in serviceMenu" :key="index" class="menu-item">
              <router-link :to="item.link" class="menu-item-info">
                <h3 class="menu-item-title">{{ item.name }}</h3>
                <div class="menu-item-more">查看更多</div>
              </router-link>
              <img :src="require(`@/assets/image/service/menu-bg${index}.png`)" class="menu-item-img" />
            </li>
          </ul>
        </div>
        <div class="skeleton">
          <div class="title">
            <h2>验收审定服务</h2>
            <p>Business Profile</p>
          </div>
          <div class="con">
            <img src="@/assets/image/service/business-profile.png" class="business-profile-img" />
          </div>
        </div>
        <div class="skeleton way">
          <div class="title">
            <h2>标准及办法</h2>
            <p>STANDARDS & METHODS</p>
          </div>
          <div class="way-con">
            <div class="way-con-box">
              <img class="way-con-box-img way-con-box-left" src="@/assets/image/service/sm-1.png" alt="" />
              <div class="way-con-box-list">
                <h4 class="way-con-box-list-title">标准</h4>
                <ul class="way-con-box-list-ul">
                  <li v-for="(item, index) in standardList" :key="index">
                    · <router-link class="way-con-box-list-li" :to="`/service/article-detail?type=0&artId=${ item.id }`">{{ item.title }}</router-link>
                  </li>
                </ul>
                <router-link to="/service/articleList?type=0" class="way-con-box-list-btn">查看详情</router-link>
              </div>
            </div>
            <div class="way-con-box">
              <div class="way-con-box-list way-con-box-left">
                <h4 class="way-con-box-list-title">审定验收管理办法</h4>
                <ul class="way-con-box-list-ul">
                  <li class="way-con-box-list-li" v-for="(item, index) in methodList" :key="index">
                    · <router-link class="way-con-box-list-li" :to="`/service/article-detail?type=1&artId=${ item.id }`">{{ item.title }}</router-link>
                  </li>
                </ul>
                <router-link to="/service/articleList?type=1" class="way-con-box-list-btn">查看详情</router-link>
              </div>
              <img class="way-con-box-img" fit="cover" src="@/assets/image/service/sm-2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import { serviceMenu } from "@/utils/const.js";
import { getNewsList, getBanner } from "@/api/news.js";

export default {
  data() {
    return {
      // way: [
      //   [{
      //     id: 1,
      //     name: "场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   },
      //   {
      //     id: 2,
      //     name: "面层审定场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   },
      //   {
      //     id: 3,
      //     name: "芯片审定场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   }],[
      //   {
      //     id: 4,
      //     name: "器材审定场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   },
      //   {
      //     id: 5,
      //     name: "步道审定场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   },
      //   {
      //     id: 6,
      //     name: "培训&注册场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收场地验收",
      //     img: "",
      //   }]
      // ],
      serviceMenu,
      standardList: [],
      methodList: [],
      bannerImg: ''
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
  },
  methods: {
    getBannerImg(){
      getBanner(["bizBgImg"]).then(res=>{
        this.bannerImg = res.data ? JSON.parse(res.data.bizBgImg)[0] : require("../../assets/image/service/bg.jpeg");
      })
    },
    getList(){
      getNewsList({
        categorys: '标准',
        pageIndex: 1,
        pageSize: 5,
      }).then(res=>{
        this.standardList = res.data.list;
      });
      getNewsList({
        categorys: '办法',
        pageIndex: 1,
        pageSize: 5,
      }).then(res=>{
        this.methodList = res.data.list;
      });
    }
  },
  mounted() {
    this.getList();
    this.getBannerImg();
  },
};
</script>

<style lang="scss" scoped>
.certificate-service{
  line-height: 1;
  .banner{ 
    width: 100%;
    height: 580px;
    background-color: #000000;
    color: #fff;
    text-align: center;
    box-sizing: border-box;
    // background: url('../../assets/image/service/bg.jpeg') no-repeat center;
    // background-size: cover;
    margin-bottom: 40px;
    position: relative;
    &-bgimg{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &-mask{
      background: rgba(0, 0, 0, .3);
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      position: absolute;
    }
  }  
  .banner-title{
    margin-top: 242px;
    font-size: 40px;
    font-family: BDZYJT--GB1-0, BDZYJT--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 46px;
    margin-bottom: 35px;
  }
  .banner-title-f{
    width:320px;
    display: inline-block;
    vertical-align: bottom;
  } 
  .banner-btn{
    display: block;
    text-decoration: none;
    width: 300px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    border: 1px solid #FFFFFF;
    font-size: 24px;
    font-weight: 600;
    color: #FFFFFF;
    margin: 0 auto;
    cursor: pointer;
  }
  .content{
    width: var(--main-width);
    max-width: 96%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-bottom: 100px;
    min-height: calc(100vh - var(--nav-menu-height) - var(--foot-height));
    .service-menu{
      .menu-list{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
          .menu-item{
              width: calc((100% - 60px) / 5);
              margin-bottom: 20px;
              background-color: #eee;
              position: relative;
              &-title{
                  font-size: 20px;
                  font-weight: normal;
                  color: #fff !important;
              }
              &-more{
                  width: 100px;
                  height: 34px;
                  line-height: 34px;
                  border-radius: 4px;
                  border: 1px solid #fff;
                  color: #fff;
              }
          }
        .menu-item-info{
          position: absolute;
          top: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;    
          justify-content: space-evenly;
          align-items: center;
          text-align: center;
          width: 100%;
          box-sizing: border-box;  
          padding: 4px 0;
          text-decoration: none;
        }
        .menu-item-img{
          width: 100%;
          height: auto;
          vertical-align: bottom;
        }
      }
    }
    .business-profile-img{
      width: 100%;
      height: auto;
      margin-bottom: 20px;
    }
    .skeleton{
      margin-top: 60px;
      width: 100%;
      .title{
          text-align: center;
          margin-bottom: 40px;
          h2{
            font-size: 38px;
            font-weight: 500;
            color: #DA5351;
            line-height: 38px;
            margin-bottom: 16px;
          }
          p{
              color: #999999;
              font-size: 18px;
              line-height: 24px;
          }
      }
      .way-con{
        margin-bottom: 80px;
        &-box{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: 275px;
          margin-top: 60px;
          &-img{
            width: 40.83%;
            object-fit: cover;
          }
          &-left{
            margin-right: 10px;
          }
          &-list{
              position: relative;
              flex: 1;
              max-width: 660px;
              height: 100%;
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              overflow: hidden;
              &-title{
                  font-size: 24px;
                  line-height: 33px;
                  color: #333;
                  margin-bottom: 24px;
              }
              &-ul{
                  list-style-type:square;
                  overflow: hidden;
                  margin-bottom: 30px;
              }
              &-li{
                  line-height: 30px;
                  color: #666666;
                  font-size: 16px;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  word-break: keep-all;
                  white-space: nowrap;      
                  text-decoration: none;                     
              }
              &-btn{
                  width: 100px;
                  height: 36px;
                  line-height: 36px;
                  text-align: center;
                  border-radius: 18px;
                  border: 1px solid #DA5351;
                  background-color: #fff;
                  color: #DA5351;
                  cursor: pointer;
                  text-decoration: none;
              }                                
          }
        }
      }
    }
  }    
}
@media screen and (max-width:960px){
  .certificate-service{
    font-size: .14rem;
    padding-top: var(--nav-menu-height);
    .header{
        margin-bottom: .16rem;
    }
    .banner{
      height: 2.10rem;
      margin-bottom: .16rem;
      .banner-title-f{
        margin-top: .65rem;
        width: 1.92rem;
        margin-bottom: .20rem;
      }
      .banner-btn{
        width: 1rem;
        height: .32rem;
        line-height: .32rem;
        font-size: .16rem;
      }
    }
    .content{
      width: 100%;
      max-width: 100%;
      padding: 0 .16rem .32rem;
      box-sizing: border-box;
      .service-menu{
        .menu-list{
          .menu-item{
            width: .62rem;
            margin-bottom: .08rem;
          }
          .menu-item-info{
            .menu-item-title{
              font-size: .12rem;
              line-height: .12rem;
            }
            .menu-item-more{
              display: none;
            }
          }
        }
      }
      .skeleton{
        margin-top: .24rem;
        .title{
          margin-bottom: .16rem;
          h2{
            font-size: .20rem;
            line-height: 1; 
            color: #333333;
            margin-bottom: .08rem;
          }
          p{
            font-size: .12rem;
            line-height: 1;
          }
        }
        .business-profile-img{
          margin-bottom: .08rem;
        }
        .way-con-box{
          margin-top: .24rem;
          height: auto;
          &-img{
            display: none;
          }
          &-left{
            margin-right: 0;
          }
          &-list{
            max-width: unset;
            &-title{
              font-size: .18rem;
              color: #CC3B3F;
              line-height: .18rem;
              text-align: center;
              margin-bottom: .16rem;
            }
            &-ul{
                margin-bottom: .16rem;
            }
            &-li{
              height: .46rem;
              line-height: .46rem;
              border-radius: .08rem;
              padding: 0 .10rem;
              font-size: .14rem;
            }
            &-li:nth-child(odd){
              background: #F9F9F9;
            }
            &-btn{
              margin: 0 auto;    
              width: 1rem;
              font-size: .14rem;
              height: .36rem;
              line-height: .36rem;
              text-align: center;
              border-radius: .18rem;
            }
          }
        }
      }
    }
  }
}
</style>
